export default __webpack_public_path__ + "static/media/passport-7b91724a1a60af8ef3d3297681c59595.png";